import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PosIntegrationService } from '../../../../../services/pos-integration.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-link-lightspeed',
  templateUrl: './link-lightspeed.component.html',
  styleUrls: ['./link-lightspeed.component.scss'],
})
export class LinkLightspeedComponent implements OnInit {
  @Input() partner;
  @Input() selectedPOS;
  @Output() next = new EventEmitter();
  public busy = true;
  public connected = false;
  public syncing = false;
  public message = null;
  public broadcastChannel = new BroadcastChannel('LIGHTSPEED_CHANNEL');
  public win;
  public lightspeed_auth_url: string = null;
  public configurationSaved: boolean = false;

  //VERY COOL LINK
  //https://stackoverflow.com/questions/28230845/communication-between-tabs-or-windows

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private posIntegrationService: PosIntegrationService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.posIntegrationService.getLightspeedAuthURL().subscribe(
      (lightspeed: any) => {
        this.lightspeed_auth_url = lightspeed.auth_url;
      },
      (err) => {
        this.busy = false;
        this.message = this.translate.instant(
          'onboarding.messages.lightspeed_error_auth_url',
        );
      },
    );

    this.broadcastChannel.onmessage = (ev) => {
      if (ev.data === 'CONNECTED') {
        this.busy = false;
        this.connected = true;
        this.message = this.translate.instant(
          'onboarding.messages.lightspeed_connected',
        );
        setTimeout(() => {
          this.posIntegrationService
            .startFullPOSSync(this.partner.PartnerID)
            .subscribe(
              (sync) => {},
              (err) => {},
            );
          this.posIntegrationService
            .startPOSClientSync(this.partner.PartnerID)
            .subscribe(
              (sync) => {},
              (err) => {},
            );
        }, 10000);
      } else {
        this.busy = false;
        this.message = this.translate.instant(
          'onboarding.messages.lightspeed_not_connected',
        );
      }
    };

    //Check if the POS is already connected to the selected POS System
    this.busy = true;
    this.posIntegrationService
      .checkPOSIntegration(this.partner.PartnerID, this.selectedPOS.POSID)
      .subscribe(
        (result) => {
          this.message = this.translate.instant(
            'onboarding.messages.lightspeed_connected',
          );
          this.connected = true;
          this.busy = false;
          setTimeout(() => {
            this.message = null;
          }, 10000);
        },
        (err) => {
          this.busy = false;
          this.connected = false;
        },
      );
  }

  ngOnDestroy() {}

  connectLightspeed() {
    localStorage.setItem('LightspeedPartnerID', this.partner.PartnerID); //Not Ideal but cant find another easy way to pass this to the other window, and the backend makes it more challenging

    this.busy = true;
    this.connected = false;
    this.message = null;

    this.win = this.posIntegrationService.launchLightspeedAuthPopup(
      this.lightspeed_auth_url,
    );
    this.checkWindow();
  }

  checkWindow() {
    setTimeout(() => {
      if (this.win.parent === null) {
        this.busy = false;
      } else {
        this.checkWindow();
      }
    }, 2000);
  }

  done() {
    this.next.emit();
  }

  skipToHubtiger() {
    this.router.navigateByUrl('/store/calendar');
  }

  configurationUpdate(event) {
    if (event && event.configurationSaved) {
      this.configurationSaved = true;
    }
  }
}
